export const en = {
  'chart-ng': {
    controls: {
      zoomOnScroll: 'Zoom on Scroll: Active',
      blockZoomOnScroll: 'Zoom on Scroll: Inactive'
    },
    timeline: {
      selection: {
        clear: 'clear'
      },
      keyEventTooltip: {
        keyEventTooltip: 'Timeframe starts with 0 News'
      },
      emptyState: {
        processingData: 'Processing data...',
        descriptionPrefix: 'Element is being processed for matching signals data.',
        descriptionSuffix: 'Please refresh this page in a few minutes.',
        descriptionPendingNormalization:
          'This element will be processed for matching signals data during our next signals import. This can take up to a few days.',
        pendingNormalizationLink: "Don't want to wait?",
        noDataTimeframe: 'No data available for this timeframe.'
      }
    }
  }
};
